export default "__VITE_PUBLIC_ASSET__e3b6114a__"